// extracted by mini-css-extract-plugin
export var avatarContainer = "_7k-0";
export var avatarTypingWave = "_7k-i";
export var gray = "_7k-f";
export var green = "_7k-c";
export var icon = "_7k-9";
export var image = "_7k-1";
export var lg = "_7k-6";
export var md = "_7k-5";
export var presenceDot = "_7k-b";
export var red = "_7k-d";
export var sm = "_7k-4";
export var status = "_7k-a";
export var typingDot = "_7k-h";
export var typingPill = "_7k-g";
export var xl = "_7k-7";
export var xs = "_7k-3";
export var xxl = "_7k-8";
export var xxs = "_7k-2";
export var yellow = "_7k-e";